import React from 'react';
import './footer.scss';
var Footer = function () {
    return (React.createElement("footer", { className: "static-footer", role: "contentinfo" },
        React.createElement("div", { className: "clearfix" },
            React.createElement("ul", { className: "list-unstyled list-inline pull-left" },
                React.createElement("li", null,
                    React.createElement("h6", { style: { margin: 0 } }, " \u00A9 Enhance Inc. All rights reserved."))))));
};
export default Footer;
